import { PlatformAppsApiClient } from '@fourthwall/services/dist/PlatformAppsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'
import { useQueryClient } from '@tanstack/react-query'

const useCreatePlatformAppSectionMutation = createMutationHook(
  PlatformAppsApiClient.createPlatformAppClientSection,
  {
    mutationKey: ['createPlatformAppSection'],
  },
)

export const useCreatePlatformAppSection = () => {
  const queryClient = useQueryClient()
  const { createPlatformAppSectionMutation } = useCreatePlatformAppSectionMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['platformAppClient'] })
      queryClient.invalidateQueries({ queryKey: ['platformAppClients'] })
    },
  })

  return {
    createPlatformAppSection: createPlatformAppSectionMutation.mutate,
    isLoading: createPlatformAppSectionMutation.isLoading,
  }
}
